module.exports = __webpack_public_path__ + "media/images/error-icon-2c4f91ae.svg";